export class NotificacionesComprobantes
{
    facturaId :string;
    numeroDocumento:string;
    tipoDocumento:number; //tipo documento del cliente
    codigoAeroplanta :string;
    tipoMovimiento :number;
    prefijo :number;
    numero :number;
}